import {
  CANDIDATE_THEME_KEYS,
  candidateThemeBundle,
  type CandidateThemeKey
} from "../../../../packages/theme-catalog/src";

export interface SelectableTheme {
  readonly index: number;
  readonly key: CandidateThemeKey;
  readonly title: string;
}

export function themeTitle(key: CandidateThemeKey): string {
  return candidateThemeBundle(key).theme.title.zh;
}

/**
 * Themes a host can pick, derived straight from the catalog registry. The array
 * index is load-bearing: it is what the room code carries so joiners land on the
 * host's theme, so it must track CANDIDATE_THEME_KEYS order.
 */
export const AVAILABLE_THEMES: readonly SelectableTheme[] =
  CANDIDATE_THEME_KEYS.map((key, index) => ({
    index,
    key,
    title: themeTitle(key)
  }));

export const DEFAULT_THEME_INDEX = 0;

export function randomThemeIndex(): number {
  return Math.floor(Math.random() * AVAILABLE_THEMES.length);
}

export function themeKeyForIndex(index: number): CandidateThemeKey | undefined {
  return AVAILABLE_THEMES[index]?.key;
}
